const capitalizeFirstLetter = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export default (options = {}) => {
  const {
    prop = 'value',
    propTypes = [Number, String, Boolean, Array, Object],
    event = 'input',
    defaultInnerValue = null,
    innerValue = 'innerValue',
    autoEmit = false,
    defaultEmitOnMount = true,
  } = options;
  const emitEventMethodName = `emit${capitalizeFirstLetter(event)}Event`;

  const mixin = {
    model: {
      prop,
      event,
    },
    props: {
      [prop]: {
        type: propTypes,
        default: defaultInnerValue,
      },
      emitOnMount: {
        type: Boolean,
        default: defaultEmitOnMount,
      },
    },
    data() {
      return {
        [innerValue]: this[prop],
      };
    },
    methods: {
      [emitEventMethodName]() {
        this.$emit(event, this[innerValue]);
      },
    },
    watch: {
      [prop](value) {
        this[innerValue] = value;
      },
    },
    mounted() {
      if (this.emitOnMount) {
        this[emitEventMethodName]();
      }
    },
  };

  if (autoEmit) {
    // eslint-disable-next-line func-names
    mixin.watch[innerValue] = function () {
      this[emitEventMethodName]();
    };
  }

  return mixin;
};
